import React from 'react';
import { ShimmerElementsGroup, ShimmerElementType } from '@fluentui/react/lib/Shimmer';

const FieldNameShimmer = () => {
    const lineWidth = Math.floor(Math.random() * 20) + 30;
    const gapWidth = 100 - lineWidth;
    return (
        <ShimmerElementsGroup
            width="100%"
            shimmerElements={[
                { type: ShimmerElementType.line, width: lineWidth + '%' },
                { type: ShimmerElementType.gap, width: gapWidth + '%' },
            ]}
        />
    );
};

export default FieldNameShimmer;
